import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

type TextBoxColor = 'bg-primary-solid' | 'bg-brand-primary' | 'bg-secondary';

// TODO: Once Contentful is updated, remove the legacy color support
const legacyColorToStandard = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']): TextBoxColor => {
  if (backgroundColor === 'black') return 'bg-primary-solid';
  if (backgroundColor === 'light green') return 'bg-brand-primary';
  if (backgroundColor === 'white') return 'bg-secondary';
  return 'bg-secondary';
};

const getBackgroundColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  const standardColor = legacyColorToStandard(backgroundColor);
  // All Other colors should fallback to branded colors
  return cssVar(standardColor);
};

const getBackgroundTextColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  const standardColor = legacyColorToStandard(backgroundColor);
  if (standardColor === 'bg-primary-solid') return cssVar('gray-dark-50');
  if (standardColor === 'bg-brand-primary') return cssVar('text-primary');
  if (standardColor === 'bg-secondary') return cssVar('text-primary');
  return cssVar('text-primary');
};

export const ColoredTextBoxContainer = styled.div<{ backgroundColor: ColoredTextBoxContentModel['backgroundColor'] }>`
  padding: ${cssVar('spacing-4xl')};
  margin: 2rem 0;
  border-radius: 1rem;
  background-color: ${({ backgroundColor }) => getBackgroundColor(backgroundColor)};
  color: cssVar('text-tertiary');

  h5.ast-h5-element {
    padding-top: 0;
    text-transform: capitalize;
    font-size: ${cssVar('font-size-display-xs')};
    font-weight: ${cssVar('font-weight-semibold')};
    line-height: ${cssVar('line-height-display-xs')};
    color: ${({ backgroundColor }) => getBackgroundTextColor(backgroundColor)};
  }

  p.ast-p-element {
    margin: ${cssVar('spacing-xl')} 0em 0em;
    font-size: ${cssVar('font-size-text-lg')};
    line-height: ${cssVar('line-height-text-lg')};
    color: ${cssVar('text-tertiary')};
  }

  a.ast-a-element {
    color: inherit !important;
  }
`;
